@if (a11yAltText()) {
  <p class="sr-only" [id]="a11yAltTextId">{{ a11yAltText() }}</p>
}
<button
  mat-button
  type="button"
  [ngClass]="{
    '!border-solid !border !h-12': outlined(),
    'kitsune-menu__collapse': collapseOnMobile(),
  }"
  [class]="`kitsune-menu !min-w-12 ${buttonClass()}`"
  [attr.aria-labelledby]="a11yAltText() ? a11yAltTextId : null"
  aria-haspopup="menu"
  (click)="open()"
  [disabled]="loading()"
  #menuButton
>
  <div class="flex items-center lg:gap-2">
    @if (icon()) {
      <lib-svg
        [svg]="icon()"
        [class]="iconClass() + ' group-[.custom-theme]/body:fill-[--basic-white]'"
        [ngClass]="{
          'fill-[--color-text-icon-primary]': lightTheme(),
          'fill-white': !lightTheme(),
          'sr-only sm:not-sr-only !hidden lg:!block': collapseOnMobile(),
        }"
      />
    }
    @if (label()) {
      <span
        class="font-bold text-base 2xl:text-xl text-nowrap group-[.custom-theme]/body:!text-[--basic-white]"
        [ngClass]="{
          'text-[--color-text-primary]': lightTheme(),
          'text-white': !lightTheme(),
        }"
        [class]="textClass()"
      >
        {{ label() }}
      </span>
    }
    @if (displayArrow()) {
      <lib-svg
        svg="fontawesome/angle-down"
        [class]="
          `[&_svg]:w-3 [&_svg]:h-3 group-[.custom-theme]/body:!fill-[--basic-white] transition-transform duration-200 ease-in-out ${arrowIconClass()}`
        "
        [ngClass]="{
          'sr-only sm:not-sr-only !hidden lg:!block': collapseOnMobile(),
          'fill-[--neutral-800]': lightTheme(),
          'fill-white': !lightTheme(),
          'rotate-180': isOpen(),
        }"
      />
    }
    @if (loading()) {
      <mat-spinner class="ml-2" [diameter]="30" />
    }
  </div>
</button>
<ng-template #menuContent>
  @for (item of menuItems; track item) {
    <div class="hover:bg-[--color-gray-opacity]" [ngClass]="{ 'flex items-center': item.icon() }">
      @if (item.menuItemLink()?.routerLink) {
        <a
          class="px-4 w-full"
          [ngClass]="{ '!flex flex-row gap-2 items-center': item.icon() }"
          [routerLink]="item.menuItemLink().routerLink"
          [routerLinkActive]="item.menuItemLink().routerLinkActive ?? ''"
          [queryParams]="item.menuItemLink().queryParams"
          [queryParamsHandling]="item.menuItemLink().queryParamsHandling"
          [fragment]="item.menuItemLink().fragment"
        >
          <ng-container *ngTemplateOutlet="itemContent; context: { item: item }" />
        </a>
      } @else if (item.menuItemLink()?.rawUrl) {
        <a
          class="px-4 w-full"
          [ngClass]="{ '!flex flex-row gap-2 items-center': item.icon() }"
          [attr.href]="item.menuItemLink().rawUrl"
        >
          <ng-container *ngTemplateOutlet="itemContent; context: { item: item }" />
        </a>
      } @else {
        <button
          type="button"
          class="w-full px-4"
          (click)="close()"
          [ngClass]="{ '!flex flex-row gap-2 items-center': item.icon() }"
        >
          <ng-container *ngTemplateOutlet="itemContent; context: { item: item }" />
        </button>
      }
    </div>
  }
</ng-template>

<ng-template #itemContent let-item="item">
  @if (item.icon()) {
    <lib-svg
      [svg]="item.icon()"
      [class]="`group-[.custom-theme]/body:fill-[--basic-white] ${iconClass()}`"
      [ngClass]="{
        'fill-[--neutral-800]': lightTheme(),
        'fill-white': !lightTheme(),
      }"
    />
  }
  <div class="flex-1">
    <ng-template [ngTemplateOutlet]="item.template" />
  </div>
</ng-template>
